import React from 'react'
import BePartner from '../Home/BePartner'

const ContactPage = () => {
  return (
    <>
        <BePartner/>
    </>
  )
}

export default ContactPage